import { IRootReducer } from '../../types/reducerTypes'
import { createSelector } from 'reselect'

export const selectMemecoins = ({ memecoins }: IRootReducer) =>
  memecoins.memecoins.filter(Boolean) || []

export const selectMemecoinById = (id: string) =>
  createSelector(selectMemecoins, (memecoins) =>
    memecoins.find((memecoin) => memecoin._id === id),
  )

export const selectMemecoinByAddress = (address: string) =>
  createSelector(selectMemecoins, (memecoins) => {
    return memecoins.find((memecoin) => memecoin?.poolAddress?.toLowerCase() === address.toLowerCase())
  })

export const selectTransactions = ({ memecoins }: IRootReducer) =>
  memecoins.transactions

export const selectMemecoinTransactions = () =>
  createSelector(
    selectTransactions,
    (transactions) => transactions ?? { data: [] },
  )

export const selectInfluencers = ({ memecoins }: IRootReducer) =>
  memecoins.influencers

export const selectMemecoinComments = ({ memecoins }: IRootReducer) =>
  memecoins.comments

export const selectShouldRefetchCurrentMemecoin = ({ memecoins }: IRootReducer) =>
  memecoins.shouldRefetchCurrentMemecoin
